import React, { useEffect } from 'react';
import { NavButton } from './NavButton';
import { Avatar, createTheme, Divider, InputLabel, ListItemIcon, Menu, MenuItem, Select, SvgIcon, ThemeProvider } from '@mui/material';
import { Link } from 'react-router';

export function NavHeader({ maxScroll = 300, windowWidth }) {
  useEffect(() => {
    const navbar = document.getElementById('NavHeader');
    const _maxScroll = maxScroll;

    window.addEventListener('scroll', function () {
      const scrollPos = window.scrollY;
      const opacity = Math.min(scrollPos / _maxScroll, 1);
      navbar.style.backgroundColor = `rgba(63, 88, 150, ${opacity})`;
      navbar.style.boxShadow = `rgba(0, 0, 0, ${Math.min(opacity, 0.35)}) 0px 4px 5px`;
    });
  }, []);

  return (
    <>
      <div id='NavHeader'>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px' }}>
          <Link to={'/'}>
            <img onClick={() => {}} alt='Sókn Engineering' src='Images/SoknBasicLogo.png' draggable={false} width={65} height={35} />
          </Link>

          {windowWidth > 750 && (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
              <NavButton text={'Home'} link={'/'} />
              <NavButton text={'Our Approach'} link={'/ourapproach'} />
              <NavButton text={'Proven & Evolving'} link={'/provenandevolving'} />

              <ThemeProvider theme={theme}>
                <Select
                  variant='standard'
                  disableUnderline
                  displayEmpty
                  IconComponent={DropdownArrow}
                  renderValue={() => {
                    return 'About';
                  }}>
                  <Link draggable={false} to={'/careeropportunities'} className='dropdownButton'>
                    Career Opportunities
                  </Link>
                  <Link draggable={false} to={'/industry'} className='dropdownButton'>
                    Industry
                  </Link>
                  <Link draggable={false} to={'/missionstatement'} className='dropdownButton'>
                    Mission Statement
                  </Link>
                  <Link draggable={false} to={'/stem'} className='dropdownButton'>
                    STEM
                  </Link>
                </Select>
              </ThemeProvider>
            </div>
          )}
        </div>

        {windowWidth > 750 && (
          <div style={{ width: 'fit-content', height: 'fit-content' }}>
            <NavButton className='navButtonAction' text={'Contact Us'} trailingIcon={'Icons/RightArrow2.svg'} link={'/contact'} color={'#749dff'} />
          </div>
        )}

        {windowWidth < 750 && (
          <>
            <ThemeProvider theme={theme}>
              <Select
                variant='standard'
                disableUnderline
                displayEmpty
                IconComponent={DropdownArrow}
                renderValue={() => {
                  return 'Menu';
                }}>
                <Link draggable={false} to={'/'} className='dropdownButton'>
                  Home
                </Link>
                <Link draggable={false} to={'/ourapproach'} className='dropdownButton'>
                  Our Approach
                </Link>
                <Link draggable={false} to={'/provenandevolving'} className='dropdownButton'>
                  Proven & Evolving
                </Link>
                
                <Divider />

                <Link draggable={false} to={'/careeropportunities'} className='dropdownButton'>
                  Career Opportunities
                </Link>
                <Link draggable={false} to={'/industry'} className='dropdownButton'>
                  Industry
                </Link>
                <Link draggable={false} to={'/missionstatement'} className='dropdownButton'>
                  Mission Statement
                </Link>
                <Link draggable={false} to={'/stem'} className='dropdownButton'>
                  STEM
                </Link>

                <Divider />

                <Link style={{ backgroundColor: 'var(--ButtonLight)' }} draggable={false} to={'/contact'} className='dropdownButton'>
                  Contact
                </Link>
              </Select>
            </ThemeProvider>
          </>
        )}
      </div>
    </>
  );
}

function DropdownArrow(props) {
  return (
    <>
      <SvgIcon viewBox='0 0 12 12' {...props}>
        <path
          d='M6.02441 1.65277C6.68102 1.65277 7.3312 1.7821 7.93783 2.03337C8.54446 2.28465 9.09566 2.65294 9.55995 3.11724C10.0242 3.58153 10.3925 4.13273 10.6438 4.73935C10.8951 5.34598 11.0244 5.99616 11.0244 6.65277C11.0244 7.97885 10.4976 9.25062 9.55995 10.1883C8.62227 11.126 7.3505 11.6528 6.02441 11.6528C5.36781 11.6528 4.71763 11.5234 4.111 11.2722C3.50437 11.0209 2.95317 10.6526 2.48888 10.1883C1.5512 9.25062 1.02441 7.97885 1.02441 6.65277C1.02441 5.32669 1.5512 4.05492 2.48888 3.11724C3.42656 2.17956 4.69833 1.65277 6.02441 1.65277ZM3.52441 5.65277L6.02441 8.15277L8.52441 5.65277H3.52441Z'
          fill='white'
        />
      </SvgIcon>
    </>
  );
}

const theme = createTheme({
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiSelect: {
      styleOverrides: {
        standard: {
          backgroundColor: '#5472b8',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '5px',
          paddingLeft: '10px',
          paddingRight: '26px !important',
          paddingTop: '2px',
          paddingBottom: '3px',
          fontFamily: 'Jura',
        },
        icon: {
          top: '6px',
          right: '6px',
          height: '16px',
          width: '16px',
          display: 'flex',
          alignContent: 'center',
          alignItems: 'center',
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {},
      },
    },
    MuiPaper: {
      styleOverrides: {
        elevation: {
          borderRadius: '10px',
          backgroundColor: 'white',
        },
      },
    },
  },
});
